import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	feedbackTitle: {
		id: 'business-list.list-migration-feedback.feedback-title',
		defaultMessage: 'What should happen to your List view preferences?',
		description: 'Feedback title',
	},
	feedbackTitleDetails: {
		id: 'business-list.list-migration-feedback.feedback-title-details',
		defaultMessage: "We're merging List view into All work.",
		description: 'Feedback title details',
	},
	feedbackTextareaLabel: {
		id: 'business-list.list-view.list-migration-feedback.feedback-textarea-label',
		defaultMessage: 'Tell us why?',
		description: 'Free form text area to understand the users reasons',
	},
	noMigrateSettings: {
		id: 'business-list.list-view.list-migration-feedback.feedback-options.no-migrate-settings',
		defaultMessage: "I'm happy to start fresh in the new All work view",
		description: 'No migration settings option',
	},
	migrateSettings: {
		id: 'business-list.list-view.list-migration-feedback.feedback-options.migrate-settings',
		defaultMessage: "It's important to keep my current view settings",
		description: 'Migration settings option',
	},
	feedbackOptionsLabel: {
		id: 'business-list.list-view.list-migration-feedback.feedback-options.feedback-options-label',
		defaultMessage:
			"To help make the transition smoother, we'd like to know how important it is to keep your current view settings (like grouping, hidden columns, and hierarchy). We'll confirm your choice before any changes happen.",
		description: 'Feedback label for migration response',
	},
	feedbackSubmitButton: {
		id: 'business-list.list-view.list-migration-feedback.feedback-submit-button',
		defaultMessage: 'Give feedback',
		description: 'Primary button for migration feedback survey',
	},
});
